export default __webpack_public_path__ + "static/powell-e2c4cd42b68479037133af35194a1bca.jpg";